import { Updatable } from '../../..';

export type TBankInstallmentPromocode = { _id?: string; _isNew?: boolean; key: string; value: string };
export default class TBankInstallmentSettings extends Updatable {
    public shopId: string;
    public showcaseId: string;
    public password: string;
    public testMode: boolean;
    public widgetMode: boolean = true;
    public promoCodes: TBankInstallmentPromocode[] = [];
    public flexible: boolean = true;

    constructor(settings?: Partial<TBankInstallmentSettings>) {
        super();
        if (settings) this.update(settings);
    }

    update(settings: Partial<TBankInstallmentSettings>, allowUndefined = false) {
        super.update(settings, allowUndefined);
    }
}